import {
  DEFAULT_LANGUAGE,
  isSupportedLanguage,
  type SupportedLanguage,
} from "./config";

const STORAGE_KEY = "workloop_lang";

export function readPathLanguage(pathname: string): SupportedLanguage | null {
  const segments = pathname.split("/").filter(Boolean);
  const first = segments[0];
  return isSupportedLanguage(first) && first !== "en" ? first : null;
}

export function readStoredLanguage(): SupportedLanguage {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return isSupportedLanguage(v) ? v : DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
}

export function persistLanguage(lng: SupportedLanguage) {
  try {
    window.localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    // localStorage unavailable; ignore
  }
}
